import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M 0,6.6145843 2.2798098,5.1336485 1.2632731,2.5265463 3.9355456,2.7374443 4.5705647,5.6094802e-7 6.6145836,1.8221752 8.6586024,0 9.2936205,2.7374443 11.965894,2.5265458 10.949357,5.1336485 13.229167,6.6145836 10.949357,8.0955186 11.965894,10.70262 9.2936205,10.491723 8.6586024,13.229167 6.6145836,11.406992 4.5705647,13.229167 3.9355456,10.491723 1.2632731,10.70262 2.2798098,8.0955186 Z",
  style: {"stroke-width":"5","stroke-linejoin":"round"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _ctx.size,
    height: _ctx.size,
    viewBox: "0 0 13.229166 13.229167",
    version: "1.1"
  }, _hoisted_3, 8, _hoisted_1))
}